import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/native';
import { Cursor } from 'react-native-confirmation-code-field';
import Colors from '../colors';
import Text from '../text';
const View = styled.View`
  height: 56px;
  width: ${_ref => {
  let {
    cellWidth
  } = _ref;
  return cellWidth;
}}px;
  align-items: center;
  justify-content: center;
  border-width: 1px;
  border-color: ${_ref2 => {
  let {
    error
  } = _ref2;
  return error ? Colors.error300 : Colors.lightGray400;
}};
  background-color: ${Colors.lightGray100};
  border-radius: 4px;
`;
export default function Cell(props) {
  const {
    index,
    cellFocused,
    symbol,
    secureTextEntry,
    error,
    value,
    incrementing,
    cellWidth
  } = props;
  const [masked, setMasked] = useState(false);
  const currentIndex = value.length - 1;
  const charFocused = currentIndex === index;
  useEffect(() => {
    if (!secureTextEntry) return setMasked(false);
    if (!charFocused) return setMasked(true);
    if (incrementing) setMasked(false);
    setTimeout(() => setMasked(true), 1000);
  }, [secureTextEntry, symbol, charFocused, incrementing]);

  const renderSymbol = () => {
    if (cellFocused) return /*#__PURE__*/React.createElement(Cursor, null);
    return masked && symbol ? '●' : symbol;
  };

  return /*#__PURE__*/React.createElement(View, {
    error: error,
    cellWidth: cellWidth
  }, /*#__PURE__*/React.createElement(Text.BodyLarge, {
    color: Colors.gray600
  }, renderSymbol()));
}
Cell.defaultProps = {
  index: 0,
  cellFocused: false,
  symbol: '',
  secureTextEntry: false,
  error: false,
  value: '',
  incrementing: false,
  cellWidth: 48
};
Cell.propTypes = {
  index: PropTypes.number,
  cellFocused: PropTypes.bool,
  symbol: PropTypes.string,
  secureTextEntry: PropTypes.bool,
  error: PropTypes.bool,
  value: PropTypes.string,
  incrementing: PropTypes.bool,
  cellWidth: PropTypes.number
};
//# sourceMappingURL=cell.js.map